module.exports = __webpack_public_path__ + "static/media/CaigoyCreationsProductDesigner.17c3155b.JPG";